import React, { useEffect, useState } from 'react';
import InnerBarPersonalDetailsPresenter from './InnerBarPersonalDetailsPresenter';
import DTOInnerBarPersonalDetails from './DTOInnerBarPersonalDetails';

import { useAppDispatch, useAppSelector } from '../../../infra/hooks';
import { setLoading } from '../../../infra/aggregates/LoaderSlice';
import { seEmpStatus } from '../../../infra/aggregates/empStatusSlice';
import { commonServices } from '../../../api/services/commonServices';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
interface empDetailInnerBarProps {
  name: string;
  designation: string;
  profilePic: any;
  award?: any;
}
function InnerBarPersonalDetailsController() {
  const selector = useAppSelector((state) => state);
  const { t } = useTranslation();

  const [empDetail, setEmpDetail] = useState<empDetailInnerBarProps>({
    designation: '',
    name: '',
    profilePic: {},
    award: [],
  });
  const [empStatusFirstTime, setEmpStatusFirstTime] = useState<any>();

  const dispatch = useAppDispatch();
  const isLoadingEmpStatus = useAppSelector(
    (state) => state.LoaderSlice.Loading,
  );
  function callback(data: empDetailInnerBarProps) {
    setEmpDetail({
      name: data.name,
      designation: data.designation,
      profilePic: data.profilePic,
      award: data.award,
    });
  }
  const getEmpStatus = useAppSelector((state) => state.empStatusSlice.status);

  /* async function changeEmpStatus() {
    dispatch(setLoading(true));
    if (selector.authSlice.emp_id && selector.authSlice.company_id) {
      const response: any = await commonServices.empStatus(
        selector.authSlice.emp_id,
        selector.authSlice.company_id
      );
      if (response.response == "success") {
        dispatch(setLoading(false));
        dispatch(seEmpStatus(response?.data?.value));
        toast.success(response?.data?.msg);
      } else {
        dispatch(setLoading(false));
        return;
      }
    }
  } */
  async function changeEmpStatus() {
    try {
      dispatch(setLoading(true));

      const emp_id = selector.authSlice.emp_id;
      const company_id = selector.authSlice.company_id;

      if (emp_id && company_id) {
        const response: any = await commonServices.empStatus(
          emp_id,
          company_id,
        );

        if (response.response === 'success') {
          dispatch(seEmpStatus(response?.data?.value));
          toast.success(response?.data?.message || response?.data?.msg);
        } else {
          toast.error(
            response?.message || response?.data?.msg || 'Failed to change employee status.',
          );
        }
      } else {
        toast.error('Missing employee or company ID.');
      }
    } catch (error: any) {
      dispatch(seEmpStatus(getEmpStatus));
      toast.error(error?.error?.data || 'An unexpected error occurred.');
    } finally {
      dispatch(setLoading(false));
    }
  }
  const ChecktheStatus = (status: any) => {
    setEmpStatusFirstTime(status);
  };

  return (
    <div>
      <DTOInnerBarPersonalDetails
        setEmployeeDetail={callback}
        //setEmpStatus={getEmpStatus}
        empStatusFirstTime={empStatusFirstTime}
      />
      <InnerBarPersonalDetailsPresenter
        employeeDetail={empDetail}
        emp_status={getEmpStatus}
        callBackEmpStatus={changeEmpStatus}
        status_laoder={isLoadingEmpStatus}
        trans={t}
        ChecktheStatus={ChecktheStatus}
      />
    </div>
  );
}

export default InnerBarPersonalDetailsController;
